import moment from 'moment-timezone';
import { FETCH_SIDE_BY_SIDE } from '../constants';
import config from '../../../../../../config';

const calendarState = {
  start: `${config.availableHours.start.hours}:00:00`,
  end: `${config.availableHours.end.hours}:00:00`,
};

const calendar = (state = calendarState, action) => {
  switch (action.type) {
    case FETCH_SIDE_BY_SIDE:
      return {
        start: moment.tz(action.payload.calendar.start, action.payload.calendar.timezone).format('H:mm:ss'),
        end: moment.tz(action.payload.calendar.end, action.payload.calendar.timezone).format('H:mm:ss'),
      };
    default:
      return state;
  }
};

export default calendar;
